import moment from 'moment'

const PLAIN_DECIMAL = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/

// Shifts the decimal point of a numeric string by `places` (positive shifts
// right, i.e. multiplies by a power of ten). The shift is done on the digit
// string rather than with arithmetic so that converting a value back and
// forth between display and storage units is lossless.
function shiftDecimal (numStr, places) {
  const str = String(numStr).trim()
  const parsed = parseFloat(str)

  if (!isFinite(parsed)) {
    return NaN
  }

  // Exponential notation can't be digit-shifted; fall back to arithmetic.
  if (!PLAIN_DECIMAL.test(str)) {
    return parsed * Math.pow(10, places)
  }

  const sign = str.startsWith('-') ? '-' : ''
  const [intPart, fracPart,] = str.replace(/^[+-]/, '').split('.')
  const whole = intPart || '0'
  const digits = whole + (fracPart || '')
  const pointPosition = whole.length + places

  let shifted
  if (pointPosition <= 0) {
    shifted = '0.' + '0'.repeat(-pointPosition) + digits
  } else if (pointPosition >= digits.length) {
    shifted = digits + '0'.repeat(pointPosition - digits.length)
  } else {
    shifted = digits.slice(0, pointPosition) + '.' + digits.slice(pointPosition)
  }

  return parseFloat(sign + shifted)
}

// percent is stored as a fraction where 1.0 === 100%, money as a whole
// number of cents. See ingest_model.data_type in reporting-models.
function multiplyBy100 (numStr) {
  return shiftDecimal(numStr, 2)
}

function divideBy100 (numStr) {
  return shiftDecimal(numStr, -2)
}

export function convertToFrontend (value, type) {
  if (type === 'boolean') {
    if (typeof value === 'string') {
    return value.toUpperCase()
    }
  }

  if (type === 'date') {
    if (moment(value).toDate() == 'Invalid Date') {
      return null
    }
    return moment(value).toDate()
  }

  if (type === 'time') {
    return moment(value, 'HH:mm').toDate()
  }

  if (type === 'money') {
    return divideBy100(value)
  }

  if (type === 'percent') {
    return multiplyBy100(value)
  }

  if (type === 'number') {
    return parseFloat(value)
  }
  return value
}

export function convertToBackend (value, type) {
  let newValue = value

  if (type === 'time') {
    newValue = moment(value).format('HH:mm')
    if (newValue === 'Invalid date') {
      newValue = null
    }
  }

  if (type === 'date') {
    newValue = moment(value).format('YYYY-MM-DD')
    if (newValue === 'Invalid date') {
      newValue = null
    }
  }

  if (type === 'number') {
    newValue = parseFloat(value)
  }

  if (type === 'percent') {
    const num = parseFloat(value)
    if (isNaN(num)) {
      newValue = null
    } else {
      newValue = divideBy100(value)
    }
  }

  if (type === 'money') {
    const num = parseFloat(value)
    if (isNaN(num)) {
      newValue = null
    } else {
      newValue = multiplyBy100(value)
    }
  }

  return newValue
}

export function validateValue (value, type) {

  if (type === 'money') {
    return moment(value, 'HH:mm').toDate()
  }

  return value
}
